<template>
  <div class="exception">
    <LayoutHeader></LayoutHeader>
    <div class="exception__main-wrapper flex flex--align-center flex--justify-center">
      <div class="exception__main">
        <div class="exception__type">404</div>
        <div class="exception__description">该页面未找到，请返回首页</div>
        <Button @click="handleBackToIndex" type="primary" shape="circle">返回首页</Button>
      </div>
    </div>
  </div>
</template>

<script>
import LayoutHeader from '@/components/layout/layoutHeader.vue';
import { toIndexRoute } from '@/utils/util';
import { mapState } from 'vuex';

export default {
  name: 'exception404',

  computed: {
    ...mapState('user', ['menuList']),
  },
  components: {
    LayoutHeader,
  },
  methods: {
    handleBackToIndex() {
      toIndexRoute(this.menuList, this.$router);
    },
  },
};
</script>

<style lang="less">
  .exception{
    height: 100vh;
    &__main-wrapper{
      height: ~'calc(100% - 48px)';
      margin-top: -48px;
    }
    &__main{
      text-align: center;
      margin-top: -50px;
    }
    &__type{
      font-size: 224px;
      color: rgba(0, 0, 0, 0.12);
      font-weight: 300;
    }
    &__description{
      font-size: 32px;
      line-height: 48px;
      color: rgba(0, 0, 0, 0.26);
      margin-bottom: 30px;
    }
    .ivu-btn{
      padding: 0;
      height: 36px;
      width: 160px;
    }
  }
</style>
